export default "__VITE_ASSET__CtLP$xgQ__"